export default {
  bugsnagApiKey: 'e35d7136cee78d344ccffdbd5ca710fa',
}
